import { AscResponse, BatchLogTimeSpentResponse } from '@shared/models';
import { httpService } from '../../utilities/axios.service';
import { TimeSpentEndpoints } from './time-spent.endpoints';

export type BatchTimeLogType = {
  startTime: string;
  endTime: string;
  activityId?: string;
  attempt?: number;
};

export async function batchLogTimeSpentApi(batchTimeLog: BatchTimeLogType[]) {
  return httpService
    .post<AscResponse<BatchLogTimeSpentResponse>>(
      TimeSpentEndpoints.batchLogTimeSpent,
      { batch: batchTimeLog }
    )
    .then((res) => res?.data?.data);
}
